export default {
    CREATE_FOLDER: "Создание папки",
    EDIT_FOLDER: "Редактирование папки",
    NAME: "Название папки",
    NAME_PLACEHOLDER: "Введите название папки",
    CREATE: "Создать",
    SAVE: "Сохранить",
    CANCEL: "Отменить",
    BACK: "Назад"
};
